

function createToolTip(positionX, positionY, htmlBody) {
  const toolTip = document.createElement('div');
  toolTip.appendChild(htmlBody);

  const arrow = createArrow();
  toolTip.appendChild(arrow);

  const innerArrow = createInnerArrow();
  toolTip.appendChild(innerArrow);

  toolTip.setAttribute('data-top', positionY);
  toolTip.setAttribute('data-left', positionX);
  toolTip.style.position = 'absolute';
  toolTip.style.border = '1px solid #ccc';
  toolTip.style.backgroundColor = '#fff';
  toolTip.style.display = 'none';
  toolTip.style.zIndex = 99;

  return toolTip;
}
function createArrow() {
  const arrow = document.createElement('div');
  arrow.style.width = 0;
  arrow.style.height = 0;
  arrow.style.borderLeft = '20px solid transparent';
  arrow.style.borderRight = '20px solid transparent';
  arrow.style.borderTop = '20px solid #ccc';

  arrow.style.top = '20px';
  arrow.style.position = 'relative';
  arrow.style.float = 'left';

  return arrow;
}
function createInnerArrow() {
  const arrow = document.createElement('div');
  arrow.style.width = 0;
  arrow.style.height = 0;
  arrow.style.borderLeft = '19px solid transparent';
  arrow.style.borderRight = '19px solid transparent';
  arrow.style.borderTop = '19px solid #fff';

  arrow.style.top = '19px';
  arrow.style.position = 'relative';

  return arrow;
}

export const createTooltip = createToolTip;
